import styles from "./iframe-test-css.module.css";
import pageStyles from "components/common/page-container.module.css";
import indexCss from "index.module.css";
import { cn } from "lib/utils";
import { Pages } from "types/common";

export const pageHeights = {
  wealth: pageStyles.wealthHeight,
  retirement: pageStyles.retirementHeight,
  family: pageStyles.familyHeight,
  education: pageStyles.educationHeight,
};

export default function Home() {
  const searchParams = new URLSearchParams(window.location.search);
  const rawUrl = searchParams.get("url");
  const iframeUrl = rawUrl ? rawUrl : "/retirement";

  const page = (rawUrl?.replace("/", "") as Pages) || "retirement";

  const heightClasses = pageHeights[page] || pageStyles.defaultHeight;

  return (
    <div className={cn(indexCss.body, styles.container)}>
      <div>
        <img
          src="/iframe/masthead.png"
          alt=""
          className={styles.imageDesktop}
        />
        <img
          src="/iframe/masthead-mobile.png"
          alt=""
          className={styles.imageMobile}
        />
      </div>

      <div className={styles.iframeContainer}>
        <div className={cn(styles.iframeWrapper, heightClasses)}>
          <iframe
            name="iFrame"
            className={styles.iframe}
            src={iframeUrl}
            frameBorder="0"
            scrolling="no"
          />
        </div>
      </div>

      <div id="contactus">
        <img src="/iframe/contact.png" alt="" className={styles.imageDesktop} />
        <img
          src="/iframe/contact-mobile.png"
          alt=""
          className={styles.imageMobile}
        />
      </div>

      <div id="disclaimer">
        <img
          src="/iframe/disclaimer.png"
          alt=""
          className={styles.imageDesktop}
        />
        <img
          src="/iframe/disclaimer-mobile.png"
          alt=""
          className={styles.imageMobile}
        />
      </div>
    </div>
  );
}
